import { useAlert } from './alert-context';
import { isErrorGloballyHandled } from 'graphql/links/error';
import { isApolloError } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

interface Options {
  showError?: (args: { title: string; body: string }) => void;
}

export function useMutationErrorHandler({ showError }: Options = {}) {
  const [t] = useTranslation();
  const showAlert = useAlert();
  if (showError == null) {
    showError = showAlert;
  }

  const mutationErrorHandler = useCallback(
    (error: Error) => {
      if (isErrorGloballyHandled(error)) {
        return;
      }

      if (isApolloError(error)) {
        const { networkError, graphQLErrors } = error;
        if (networkError) {
          showError!({
            title: t('general.errorTitle', 'Chyba'),
            body: t('general.connectionError', 'Nelze se připojit k serveru'),
          });
        } else {
          const err = graphQLErrors[0];
          showError!({
            title: t('general.errorTitle', 'Chyba'),
            body: t('general.serverError', 'Chyba serveru: {{err.message}}', {
              err,
            }),
          });
        }
      } else {
        console.error('Non-Apollo error from mutation', error);
        showError!({
          title: t('general.errorTitle', 'Chyba'),
          body: t('general.error', 'Něco se pokazilo'),
        });
      }
    },
    [showError, t],
  );
  return mutationErrorHandler;
}
